import React, { useState } from 'react';
import ChecksList from './CheckList';
import CheckDetails from './CheckDetails';
import styles from './Teamshare.module.css';
import resyncImg from '../../../../assets/images/Fireboard/resync.png';
import logoutImage from '../../../../assets/images/logout/logout.png';
import SearchBox from "../SearchBox";
import Filter from "../Filter";
import Checkbox from '../../../../components/Checkbox';
import Tooltip from "rc-tooltip";

const Teamshare = (props) => {
  const {
    selectedItem = {},
    reSync,
    onLogout,
    revenueCenters,
    onChangeFilter,
    onSearch,
    searchValue,
    paidCheck,
    filterPaidCheck,
    job,
    nameInitials,
    name,
    premise,
    togglePremise,
    showTipsInfo,
  } = props || {};
  let hideCheckDetails = !premise;
  if (!premise) {
    hideCheckDetails = Object.keys(selectedItem).length === 0 && selectedItem.constructor === Object;
  }

  const [tooltipVisible, setTooltipVisible] = useState(false);

  const renderOverlayContent = () => {
    return (
      <div className={styles.profileWrapper}>
        <div className={styles.nameWrapper}>
        {name ? <span className={styles.jobText}>{`NAME: ${name}`}</span> : null}
        </div>
        <span className={styles.jobText}>{job? `JOB: ${job.name}` : null}</span>
        <div className={styles.tips} onClick={() => {
          if (tooltipVisible) 
            setTooltipVisible(false);
          showTipsInfo();
        }}>
          <span className={styles.tipsText}>My Tips</span>
        </div>
      </div>
    )
  }

  const renderHeader = () => (
    <div className={styles.headerWrapper}>
      <div className={styles.headerLeftWrapper}>
        <img src={resyncImg} className={styles.headerIcon} alt="sync" onClick={reSync} />
        <SearchBox onSearch={onSearch} searchValue={searchValue} />
        <Filter
          onChangeFilter={onChangeFilter}
          orderTypes={revenueCenters}
        />
        <Checkbox
          name="Display Paid Checks"
          checked={paidCheck}
          onChange={e => filterPaidCheck && filterPaidCheck(e.target.checked)} />
        <Checkbox
          name={premise ? "Off Premise" : "On Premise"}
          checked={premise}
          onChange={togglePremise} />
      </div>
      <div className={styles.headerRightWrapper}>
        <Tooltip
          placement="bottomLeft"
          visible={tooltipVisible}
          overlay={renderOverlayContent()}
          trigger={"click"}
          overlayInnerStyle={{ padding: "0.93vh", width: "20vw", height: "12vh" }}
          onVisibleChange={(visible) => setTooltipVisible(visible)}
        >
          <span className={styles.initials}>{nameInitials}</span>
        </Tooltip>
        <img onClick={onLogout} className={styles.logoutStyle} src={logoutImage} alt="logout" />
      </div>
    </div>
  );

  return (
    <div>
      {renderHeader()}
      <div className={styles.container}>
        <ChecksList {...props} />
        {hideCheckDetails ? null :
          <CheckDetails {...props} />
        }
      </div>
    </div>
  );
}

export default Teamshare;
